<template>
    <Button
        @click="isOpen = true"
        iconName="plus"
        color="light"
    >
        New In Person Location
    </Button>

    <Drawer
        @close="isOpen = false"
        :show="isOpen"
        width="wide"
    >
        <template #title> New In Person Meeting Location </template>
        <template #content>
            <ApiForm
                :url="urlFactory.makeCompanyMeetingLocationStoreUrl()"
                method="POST"
                ref="apiFormRef"
            >
                <InPersonHostDefinedMeetingLocationForm
                    :errors="
                        apiFormRef?.response?.getErrors() ??
                        new ApiFormErrors({})
                    "
                />
            </ApiForm>
        </template>
        <template #actions>
            <Button
                @click="isOpen = false"
                color="light"
                :disabled="apiFormRef?.loading.valueOf()"
            >
                Cancel
            </Button>
            <Button
                @click="submitStore()"
                color="dark"
                iconName="save"
                :loading="apiFormRef?.loading.valueOf()"
            >
                Save
            </Button>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref } from 'vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import InPersonHostDefinedMeetingLocationForm from '@/App/Company/Component/InPersonHostDefineMeetingLocation/InPersonHostDefinedMeetingLocationForm.vue'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import InPersonHostDefinedMeetingLocation from '@/App/Company/Entity/InPersonHostDefinedMeetingLocation'

    const emit = defineEmits<{
        onSuccess: [
            {
                inPersonHostDefinedMeetingLocations: InPersonHostDefinedMeetingLocation[]
            },
        ]
    }>()

    const isOpen = ref<boolean>(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submitStore = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                const updatedInPersonHostDefinedMeetingLocations =
                    response.getHydratedInPersonHostDefinedMeetingLocations(
                        ResponseJsonKeyEnum.App_Company_InPersonHostDefinedMeetingLocations,
                    )

                emit('onSuccess', {
                    inPersonHostDefinedMeetingLocations:
                        updatedInPersonHostDefinedMeetingLocations,
                })
            })
            .finally(() => {
                isOpen.value = false
            })
    }
    const urlFactory = new UrlFactory()
</script>
